export {ModalComponent} from './modal.component';
export {ModalData} from './modal-data';



// WEBPACK FOOTER //
// ./src/app/modal/index.ts